export default "__VITE_ASSET__Duq$YwTr__"